export enum INDEX {
  minusTwo = -2,
  minusOne = -1,
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  six = 6,
  ten= 10
}

export enum PAGES {
  zero = 0,
  one = 1,
  ten = 10
}

export enum SORT_ID {
  default_id_sort_function = 1
}

export enum BOOKMARK {
  zero = 0,
  one = 1,
  maxSize = 5 * 1024 * 1024
}

export enum STATUS_UPDATE_MENU {
  defaultOptionsCount = 3,
  optionHeight = 36,
  contentOffset = 16,
  viewportPadding = 8,
  minHeight = 120,
  maxHeight = 280,
  width = 160
}


export enum NUMBER {
  zero = 0,
  one = 1,
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
  nine = 9,
  ten = 10,
  eleven = 11,
  twelve = 12,
  thirteen = 13,
  fourteen = 14,
  fifteen = 15,
  sixteen = 16,
  seventeen = 17,
  eighteen = 18,
  nineteen = 19,
  twenty = 20,
  hundred = 100
}

export enum FILEUPLOAD {
  MAX_SIZE = 25 * 1024 * 1024
}

export enum COMPANY_NUMBER {
  companyid = 12345,
  projectcount = 2,
  companyusercount = 74
}

export enum UPLOAD_ACTION_ID {
  arActionId = 9
}

export enum ARUPLOAD_ACTION_ID {
  arActionId = 17
}

export enum REMOVE_UPLOAD_ACTION_ID {
  arActionId = 18
}

export enum AR_REASON {
  limit = 255
}

export enum AR_EMAIL {
  msglimit = 5000,
  minlimit = 0
}

export enum L2_Approver{
  caId = 15
}
 export enum risk_email{
  caNumber = 1
 }
 export enum THIRDPARTY_DOCUMENT{
  sendrevisionemailAR = 15,
  sendrevisionemailL1 = 16,
  sendrevisionemailL2 = 17,
  po = 18,
  coi=19
 }
 export enum APPROVE_ID {
  caSectionId=15,
  arActionId = 9
}
 export enum DENY_ID {
  arActionId = 10
}
export enum APPROVE_WITH_RISK {
  caSectionId=20,
  arActionId= 16
}
export enum Approve{
  reasonId = 13
}

export enum dandB{
  maxsize = 26214400
}

export enum send_risk_email{
  departmentCount = 23
}